import React from "react";
import '../styles/layout.css';

export default function Footer() {
  return (
    <footer className="studio-footer">
      <p className="studio-footer__text">
        Copyright &copy; {new Date().getFullYear()} i-IPTV Co.,ltd. v1.0.0
      </p>
    </footer>
  );
}
